module.exports = __webpack_public_path__ + "img/Irasema Cabrera.998f24f0.jpg";